import { useState } from "react";

import { useUserStore } from "../stores/UserStore";

import "../assets/scss/components/_billing-address.scss";

export const BillingAddress = ({ callback }: { callback?: () => void }) => {
	const { userInfo, Update } = useUserStore(({ userInfo, Update }) => {
		return { userInfo, Update };
	});

	const [formFailed, setFormFailed] = useState(false);

	const [address, SetAddress] = useState({
		billing_name: userInfo.billing_information ? (userInfo.billing_information.name ?? "") : "",
		billing_line1: userInfo.billing_information ? (userInfo.billing_information.line_1 ?? "") : "",
		billing_line2: userInfo.billing_information ? (userInfo.billing_information.line_2 ?? "") : "",
		billing_town: userInfo.billing_information ? (userInfo.billing_information.town ?? "") : "",
		billing_county: userInfo.billing_information ? (userInfo.billing_information.county ?? "") : "",
		billing_country: userInfo.billing_information ? (userInfo.billing_information.country ?? "") : "",
		billing_phone: userInfo.billing_information ? (userInfo.billing_information.phone_number ?? "") : "",
		billing_postcode: userInfo.billing_information ? (userInfo.billing_information.postcode ?? "") : "",
	});

	const billingDetailsCheck = () => {
		const fields = ["billing_name", "billing_postcode", "billing_line1", "billing_town", "billing_county", "billing_country"];
		const validChecks = fields.length;
		const validConfirm = fields.filter((field) => address[field] && address[field] !== "").length;

		if (validChecks === validConfirm) {
			setFormFailed(false);
			Update(address);

			if(callback !== null) {
				callback();
			}
		} else {
			setFormFailed(true);
		}
	}

	return (
		<div className={`billing-details form-container ${formFailed ? "form-failed" : ""}`}>
			<div className="form-information">
				<h2>Your Billing Information</h2>
				<p>
					We need your billing information to be able to process your order. Please fill in or update the
					following information before proceeding.
				</p>
			</div>
			<br />
			<div className="row">
				<div className="field col-12">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						autoComplete="name"
						required
						value={address.billing_name ?? ""}
						onChange={(e) => {
							SetAddress({ ...address, billing_name: e.target.value });
						}}
					/>
					<label htmlFor="">Name</label>
				</div>
				<div className="field col-12">
					<input
						type="text"
						minLength={5}
						placeholder=" "
						required
						value={address.billing_postcode ?? ""}
						onChange={(e) => {
							e.target.value = e.target.value.toUpperCase();
							SetAddress({ ...address, billing_postcode: e.target.value });
						}}
					/>
					<label htmlFor="">Postcode</label>
				</div>
				<div className="field col-12 col-md-6">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						autoComplete="address-line1"
						value={address.billing_line1 ?? ""}
						required
						onChange={(e) => {
							SetAddress({ ...address, billing_line1: e.target.value });
						}}
					/>
					<label htmlFor="">Line 1</label>
				</div>
				<div className="field col-12 col-md-6">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						autoComplete="address-line2"
						value={address.billing_line2 ?? ""}
						onChange={(e) => {
							SetAddress({ ...address, billing_line2: e.target.value });
						}}
					/>
					<label htmlFor="">Line 2</label>
				</div>
				<div className="field col-12 col-md-6">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						value={address.billing_town ?? ""}
						required
						onChange={(e) => {
							SetAddress({ ...address, billing_town: e.target.value });
						}}
					/>
					<label htmlFor="">Town</label>
				</div>
				<div className="field col-12 col-md-6">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						value={address.billing_phone ?? ""}
						onChange={(e) => {
							SetAddress({ ...address, billing_phone: e.target.value });
						}}
					/>
					<label htmlFor="">Phone</label>
				</div>
				<div className="field col-12">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						value={address.billing_county ?? ""}
						required
						onChange={(e) => {
							SetAddress({ ...address, billing_county: e.target.value });
						}}
					/>
					<label htmlFor="">County</label>
				</div>
				<div className="field col-12">
					<input
						type="text"
						minLength={1}
						placeholder=" "
						value={address.billing_country ?? ""}
						required
						onChange={(e) => {
							SetAddress({ ...address, billing_country: e.target.value });
						}}
					/>
					<label htmlFor="">Country</label>
				</div>
			</div>
			<button
				className="btn"
				onClick={() => {
					billingDetailsCheck();
				}}
			>
				Save Billing Details
			</button>
		</div>
	);
};

export default BillingAddress;
